<template>
  <div id="sign-up-candidate-modal">
    <transition name="expand-transition">
      <div
        v-if="modalIsActive"
        class="modal"
        :class="modalIsActive ? 'is-active' : ''"
      >
        <div
          class="modal-background"
          @click="toggleModal"
        />
        <sign-up-candidate-form-card />
      </div>
    </transition>
  </div>
</template>

<script>
import SignUpCandidateFormCard from '@/components/SignUp/SignUpCandidateFormCard';

export default {
  name: 'SignUpCandidate',
  components: {
    SignUpCandidateFormCard
  },
  props: {
    modalIsActive: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    toggleModal () {
      this.$emit('toggleModal', false);
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
